"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageId = exports.SignalSelectedPageType = void 0;
var SignalSelectedPageType;
(function (SignalSelectedPageType) {
    SignalSelectedPageType["PRIMARY"] = "primary";
    SignalSelectedPageType["SECONDARY"] = "secondary";
})(SignalSelectedPageType || (exports.SignalSelectedPageType = SignalSelectedPageType = {}));
var LanguageId;
(function (LanguageId) {
    LanguageId[LanguageId["CN"] = 0] = "CN";
    LanguageId[LanguageId["EN"] = 2] = "EN";
})(LanguageId || (exports.LanguageId = LanguageId = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVnb1Byb3BzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZmVnb1Byb3BzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksc0JBR1g7QUFIRCxXQUFZLHNCQUFzQjtJQUM5Qiw2Q0FBbUIsQ0FBQTtJQUNuQixpREFBdUIsQ0FBQTtBQUMzQixDQUFDLEVBSFcsc0JBQXNCLHNDQUF0QixzQkFBc0IsUUFHakM7QUF3REQsSUFBWSxVQUdYO0FBSEQsV0FBWSxVQUFVO0lBQ2xCLHVDQUFNLENBQUE7SUFDTix1Q0FBTSxDQUFBO0FBQ1YsQ0FBQyxFQUhXLFVBQVUsMEJBQVYsVUFBVSxRQUdyQiJ9